import { FC } from 'react';

import { NUMBER_SIGN } from 'utils/constants/common';
import { MagritteNotificationName } from 'utils/constants/notification';

import { CustomChip, VSpacing } from '@hh.ru/magritte-ui';

import { addMagritteNotification } from 'store/models/notification';
import { useDispatch, useSelector } from 'store/utils';

export const EmployerInfoChip: FC = () => {
    const employerId = useSelector(({ user }) => user.user?.employerId);
    const employerName = useSelector(({ user }) => user.user?.employerName);

    const dispatch = useDispatch();

    const employerNumber = employerId ? `${NUMBER_SIGN}${String(employerId)}` : '';
    const employerChipText = `${employerNumber}${employerName ? '. ' : ''}${employerName || ''}`;

    const handleClick = async () => {
        await navigator.clipboard.writeText(employerChipText);
        dispatch(addMagritteNotification(MagritteNotificationName.CopiedToClipboard));
    };
    return (
        <>
            <VSpacing default={16} />
            <CustomChip onClick={handleClick}>{employerChipText}</CustomChip>
        </>
    );
};
